// Angular Imports
import { Injectable } from '@angular/core';

// 3rd party Imports
import { DxFormComponent } from 'devextreme-angular';
import { Subject, Observable } from 'rxjs';

// Model imports
import { ILocalContextFactory } from '../../../../dashboard-module/_interfaces/local-context-factory';

@Injectable({
    providedIn: 'root'
})
export class CBHelperService implements ILocalContextFactory {
    private readonly _subjectSelectedCommunity: Subject<any> = new Subject();
    private readonly _subjectRollbackCommunity: Subject<any> = new Subject();
    private readonly _subjectSelctedManagementCompany: Subject<any> = new Subject();
    private readonly _subjectRollbackManagementCompany: Subject<any> = new Subject();
    private readonly _subjectWidgetContext: Subject<any> = new Subject();
    private readonly _subjectFilterFormReady: Subject<boolean> = new Subject();
    private readonly _subjectForceRefresh: Subject<boolean> = new Subject();
    private readonly _subjectUpdateSecurityInfo: Subject<any> = new Subject();

    private _selectedCommunity: any;
    private _selectedManagementCompany: any;
    private _filterForm: DxFormComponent;

    getContext(): Observable<any> {
        return new Observable((observer) => {
            this._subjectSelectedCommunity.subscribe((context) => observer.next(context));
            this._subjectSelctedManagementCompany.subscribe((context) => observer.next(context));
        });
    }

    getLocalContext(): any {
        return this._selectedCommunity || this._selectedManagementCompany;
    }

    updateContext(context: any): void {
        this._selectedCommunity = null;
        this._selectedManagementCompany = null;
        if (!!context) {
            if (!!context.communityId) {
                this._selectedCommunity = context;
            } else {
                this._selectedManagementCompany = context;
            }
        }
    }

    updateWidgetContextSubject(context: any): void {
        this._subjectWidgetContext.next(context);
    }

    getWidgetContextSubject(): Observable<any> {
        return this._subjectWidgetContext;
    }

    updateSelectedCommunitySubject(community: any): void {
        this._selectedCommunity = community;
        this._selectedManagementCompany = null;
        this._subjectSelectedCommunity.next(community);
    }

    getSelectedCommunitySubject(): Observable<any> {
        return this._subjectSelectedCommunity;
    }

    updateManagementCompanySubject(property: any): void {
        this._selectedManagementCompany = property;
        this._selectedCommunity = property.communityContext;
        this._subjectSelctedManagementCompany.next(property);
    }

    getSelectedManagementCompanySubject(): Observable<any> {
        return this._subjectSelctedManagementCompany;
    }

    getSelectedCommunity(): any {
        return this._selectedCommunity;
    }

    getSelectedManagementCompany(): any {
        return this._selectedManagementCompany;
    }

    getSubjectFilterFormReady(): Subject<boolean> {
        return this._subjectFilterFormReady;
    }

    updateSubjectFilterFormReady(filterForm: DxFormComponent): void {
        this._filterForm = filterForm;
        this._subjectFilterFormReady.next(true);
    }

    getFilterForm(): DxFormComponent {
        return this._filterForm;
    }

    getSubjectForceRefresh(): Subject<boolean> {
        return this._subjectForceRefresh;
    }

    updateSubjectForceRefresh(flag: boolean): void {
        this._subjectForceRefresh.next(flag);
    }

    getSubjectSecurityInfo(): Subject<any> {
        return this._subjectUpdateSecurityInfo;
    }

    updateSubjectSecurityInfo(value: any): void {
        this._subjectUpdateSecurityInfo.next(value);
    }

    rollbackCommunityContext(community: any): void {
        this._selectedCommunity = community;
        this._selectedManagementCompany = null;
        this._subjectRollbackCommunity.next(community);

        this.updateContext(community);
        this.updateWidgetContextSubject(community);
    }

    rollbackManagementCompanyContext(property: any): void {
        this._selectedManagementCompany = property;
        this._selectedCommunity = property.communityContext;
        this._subjectRollbackManagementCompany.next(property);
    }

    getRollbackContext(): Observable<any> {
        return new Observable((observer) => {
            this._subjectRollbackCommunity.subscribe((context) => observer.next(context));
            this._subjectRollbackManagementCompany.subscribe((context) => observer.next(context));
        });
    }

    getRollbackCommunityContext(): Observable<any> {
        return this._subjectRollbackCommunity;
    }

    getRollbackManagementCompanyContext(): Observable<any> {
        return this._subjectRollbackManagementCompany;
    }
}
